var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "py-1" }, [
    _vm.hasRecipient
      ? _c("div", { staticClass: "recipient text-truncate font-weight-bold" }, [
          _vm.object.registration.email_recipient !== null
            ? _c("span", { staticClass: "text-mono" }, [
                _c("i", { staticClass: "fa fa-envelope" }),
                _vm._v(" " + _vm._s(_vm.object.registration.email_recipient)),
              ])
            : _c("span", { staticClass: "text-mono" }, [
                _c("i", { staticClass: "fa fa-lg fa-mobile-phone" }),
                _vm._v(" " + _vm._s(_vm.object.registration.recipient)),
              ]),
          _vm._v("\n         - "),
          _c("span", [_vm._v(_vm._s(_vm.object.name))]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.object.status == 3
      ? _c("span", { domProps: { innerHTML: _vm._s(_vm.formatedDate) } })
      : _vm._e(),
    _vm._v(" "),
    _vm.object.status == 1
      ? _c(
          "div",
          [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("device.registrations.expires"))),
            ]),
            _vm._v(" "),
            _c("Countdown", {
              attrs: {
                date: _vm.object.registration.liveUntil,
                timezone: _vm.timezone,
                item: _vm.object,
              },
              on: { expired: _vm.handleExpired },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.object.status == 2
      ? _c(
          "span",
          { staticClass: "font-bold phone-simple-renderer" },
          [
            _vm.phoneName != ""
              ? _c(
                  "router-link",
                  { attrs: { to: "/devices/" + _vm.object.id } },
                  [
                    _c("span", { attrs: { title: _vm.phoneName } }, [
                      _vm._v(_vm._s(_vm.phoneName)),
                    ]),
                    _vm._v(" "),
                    _c("img", { attrs: { src: _vm.urlImg } }),
                  ]
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.object.hasOlderDevice == true &&
    _vm.object.imei == null &&
    _vm.object.status != 1 &&
    _vm.object.status != 3
      ? _c("span", [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("device.registrations.previously"))),
            _c("br"),
            _c("strong", [_vm._v(_vm._s(_vm.phoneName))]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }